import React from 'react'

import { twMerge } from 'tailwind-merge'

interface SurfaceProps {
  className?: string
  children: React.ReactNode
}

export const Surface: React.FC<SurfaceProps> = ({ className, children }) => {
  return (
    <div
      className={twMerge(
        'bg-white dark:bg-primary-900 rounded-md border border-primary-300 dark:border-primary-700',
        className,
      )}
    >
      {children}
    </div>
  )
}
